import { API_CONFIG } from '../config/api';
import { authApi } from './authAwareAxios';

export async function listWallets() {
  const { data } = await authApi.get(API_CONFIG.ENDPOINTS.WALLET_BASE);
  return data;
}

/**
 * @returns {Promise<{
 *   wallet_id: string,
 *   balance: number,
 *   credit_line_limit_minor?: number|null,
 *   credit_line_depleted_minor?: number|null,
 *   currency?: string|null,
 *   owner_id?: string|null,
 *   owner_type?: string|null,
 *   deposit_instructions?: unknown,
 * }>}
 */
export async function getWallet(walletId) {
  const { data } = await authApi.get(API_CONFIG.ENDPOINTS.WALLET_DETAIL(walletId));
  return data;
}

export async function getWalletStatement(walletId, params = {}) {
  const { data } = await authApi.get(API_CONFIG.ENDPOINTS.WALLET_STATEMENT(walletId), { params });
  return data;
}

/**
 * @param {string} walletId
 * @param {string} referenceId
 * @returns {Promise<{ invoice_url: string }>} — errors return `{ message }` and non-2xx
 */
export async function getWalletInvoice(walletId, referenceId) {
  const { data } = await authApi.get(API_CONFIG.ENDPOINTS.WALLET_INVOICE(walletId, referenceId));
  return data;
}

/**
 * Transfer cash credit between two cash-credit wallets (currency CASH; source is `walletId`).
 * @param {string} walletId - Source wallet id
 * @param {{ amount_minor: number, to_wallet_id: string }} body
 */
export async function postWalletCashTransfer(walletId, body) {
  const { data } = await authApi.post(API_CONFIG.ENDPOINTS.WALLET_CASH_TRANSFER(walletId), body);
  return data;
}

/**
 * List credit issue requests for a wallet (paginated).
 * @param {string} walletId
 * @param {{ page?: number, limit?: number, status?: 'PENDING'|'APPROVED'|'REJECTED' }} params
 * @returns {Promise<{ success?: boolean, page?: number, limit?: number, total?: number, requests?: unknown[], message?: string }>}
 */
export async function listCreditIssueRequests(walletId, params = {}) {
  const { data } = await authApi.get(API_CONFIG.ENDPOINTS.WALLET_CREDIT_ISSUE_REQUESTS(walletId), {
    params,
  });
  return data;
}

/**
 * Create a credit issue (repayment) request for a wallet.
 * @param {string} walletId
 * @param {{ amount_minor: number, rrn: string, repayment_date?: number, notes?: string }} body
 */
export async function postCreditIssueRequest(walletId, body) {
  const { data } = await authApi.post(API_CONFIG.ENDPOINTS.WALLET_CREDIT_ISSUE_REQUESTS(walletId), body);
  return data;
}
